import React, { useState, useRef, useEffect } from 'react';
import SelectObjectItem from './SelectObjectItem'
import $ from 'jquery'

const SelectObject = (props) => {

    const [selected, setSelected] = useState(props.selected)
    const [items, setItems] = useState(props.items)
    const [groups, setGroups] = useState(props.groups)
    const [search, setSearch] = useState((props.selected && props.selected !== "") ? props.selected[props.fieldName] : "")
    const [placeholder] = useState(props.placeholder)

    const inputId = props.id ? props.id : "dropdownMenuLink"

    // create element ref
    const innerRef = useRef(null);

    useEffect(() => {
        if (selected !== "" && (selected === undefined || props.selected !== selected && props.selected !== "" )) {
            let newSelection = props.selected
            if (!newSelection && items && items.length === 1) {
                newSelection = items[0]
            }
            if (newSelection) {
                setSelected(newSelection);
                const newSearch = (newSelection && newSelection !== "") ? newSelection[props.fieldName] : ""
                setSearch(newSearch)
                props.onSelect(newSelection)
            }
        } else if (props.selected === "") {
            setSearch("")
        }
    });

    // useEffect(() => {
    //     const div = innerRef.current;
    //     $(div).on("hidden.bs.dropdown", hideDropdown)
    // }, []);

    //This failed the Applications page search
    // if (search !== "" && props.selected === "") {
    //     setSearch("")
    // }

    // if (search && search !== "" && props.selected && search !== props.selected[props.fieldName]) {
    //     setSearch(props.selected[props.fieldName])
    // }

    const showDropdown = () => {
        const div = innerRef.current;
        $(div).dropdown("show")
        //$(div).dropdown("show")
    }

    const onClick = (item) => {
        setSelected(item)

        setSearch((item && item !== "") ? item[props.fieldName] : "")

        props.onSelect(item)
    }

    const onChange = (e) => {
        setSelected("")
        setSearch(e.target.value)
        const search = e.target.value.toLowerCase()

        showDropdown()

        if (groups) {
            setGroups(props.groups.map(group => {
                let newGroup = { ...group }
                newGroup.items = newGroup.items.filter(item => item[props.fieldName].toLowerCase().includes(search) || item.tags && item.tags.find(a => a.toLowerCase().includes(search)))
                return newGroup
            }))
        }

        if (items) {
            setItems(props.items.filter(item => item[props.fieldName].toLowerCase().includes(search) || item.tags && item.tags.find(a => a.toLowerCase().includes(search))))
        }
    }

    return <div>
        {props.title ? props.title : ""}
        <div className="dropdown wrap-input100 validate-input">

            <input type="text" ref={innerRef}
                className="dropdown-toggle filter_selector form-control"
                id={inputId}
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                value={search}
                onChange={onChange}
                autoComplete="off"
                placeholder={placeholder}
                autoFocus={props.autoFocus}
                onClick={(e) => e.target.select()}
            />
            <span className="focus-input100" style={{ top: "-11px" }} data-symbol="&#xf002;"></span>

            <div className="dropdown-menu" aria-labelledby={inputId} >
                {groups ?
                    groups.filter(a => a.items).map((group) =>
                        <div key={group.name}>
                            <div className="select-group" style={{ borderBottom: "0px", borderLeft: "0px", borderRight: "0px", borderRadius: "0" }}>
                                <p className="select-group-title">{group.name}</p>
                                {group.items.map((item) => <SelectObjectItem item={item} name={item[props.fieldName]} description={item[props.fieldDescription]} id={item.id} key={item.id} tags={item.tags} onClick={onClick} />)}
                            </div>
                            <br />
                        </div>
                    )
                    :
                    items.map((item) => <SelectObjectItem item={item} name={item[props.fieldName]} id={item.id} key={item.id} tags={item.tags} onClick={onClick} />)
                }
            </div>
        </div>
    </div>
}

export default SelectObject